export const STATS_LOAD_SUCCESS = 'STATS_LOAD_SUCCESS';
export const STATS_LOAD_ERROR = 'STATS_LOAD_ERROR';
export const STATS_SET_DATE = 'STATS_SET_DATE';
export const STATS_SET_POSITION = 'STATS_SET_POSITION';
export const STATS_SET_CUSTOMER = 'STATS_SET_CUSTOMER';
export const STATS_SET_EMPLOYEE = 'STATS_SET_EMPLOYEE';
export const STATS_CLEAR = 'STATS_CLEAR';
export const STATS_SET_FIELD = 'STATS_SET_FIELD';
